import { render, staticRenderFns } from "./AccountBreakdown.vue?vue&type=template&id=21460bc5&scoped=true"
import script from "./AccountBreakdown.vue?vue&type=script&lang=js"
export * from "./AccountBreakdown.vue?vue&type=script&lang=js"
import style0 from "./AccountBreakdown.vue?vue&type=style&index=0&id=21460bc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21460bc5",
  null
  
)

export default component.exports